// Gestion des animations personnalisées
document.addEventListener('DOMContentLoaded', function() {
  const animationType = document.documentElement.style.getPropertyValue('--animation-type') || 'fade';
  
  // Observer pour déclencher les animations au scroll
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };
  
  const animationObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const element = entry.target;
        const animClass = element.dataset.customAnimation || animationType;
        
        // Ajouter la classe d'animation
        element.classList.add('animation-' + animClass);
        
        // Déclencher l'animation après un court délai
        setTimeout(() => {
          element.classList.add('animated');
        }, 50);
        
        // Ne plus observer cet élément
        animationObserver.unobserve(element);
      }
    });
  }, observerOptions);
  
  // Observer tous les éléments avec data-custom-animation
  document.querySelectorAll('[data-custom-animation]').forEach(element => {
    animationObserver.observe(element);
  });
  
  // Observer les éléments de section avec animation par défaut
  document.querySelectorAll('.section-body > *, .product-card').forEach(element => {
    if (!element.hasAttribute('data-custom-animation')) {
      element.setAttribute('data-custom-animation', animationType);
      animationObserver.observe(element);
    }
  });
});

// Le menu mobile utilise les styles natifs du thème selon la position définie
